import axios from '@/utils/http';

export default notice => {
  return axios
    .delete(`/advertisement_notice/${notice}`)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
